import {createSlice} from "@reduxjs/toolkit";
import {getSubscriptionDetail} from './action'

const initialState = {
  state: {
    id: '',
    auto_id: 0,
    custom_id: '',
    status: '',
    start_date: 0,
    venue_id: '',
    customer_id: '',
    expires_at: 0,
    created_at: 0,
    customer: {},
    details: [],
  },
  loading: true,
  error: ''
} as BaseState<SubscriptionDetailState>

const slice = createSlice({
  name: 'subscriptionSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // summary
    builder.addCase(getSubscriptionDetail.pending, (state) => ({
        ...state,
        loading: true
      }))
    builder.addCase(getSubscriptionDetail.fulfilled, (state, action) => ({
        state: {
          ...action.payload
        },
        error: null,
        loading: false
      }))
    builder.addCase(getSubscriptionDetail.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to get subscriptions'
      }))
  }
})

export default slice
